document.addEventListener( 'DOMContentLoaded', function() {
	'use strict';

	var hero = document.getElementById( 'js-hero-panels' );

	if ( hero === null || hero === undefined ) {
		return;
	}

	var panels = hero.getElementsByClassName( 'panel' );

	var handleMouseEnter = function( e ) {
		e.target.classList.add( '-on' );
		e.target.classList.remove( '-off' );
	};

	var handleMouseLeave = function( e ) {
		e.target.classList.add( '-off' );
		e.target.classList.remove( '-on' );
	};

	[].forEach.call( panels, function( el ) {
		el.addEventListener( 'mouseenter', handleMouseEnter );
		el.addEventListener( 'focus', handleMouseEnter );
		el.addEventListener( 'mouseleave', handleMouseLeave );
		el.addEventListener( 'blur', handleMouseLeave );
	} );

} );
